import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Megaphone } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle } from './ui/dialog';
import WbCase from '../portal/whistleblowing/WbCase';
import { ReportsTable } from '../portal/whistleblowing/WbManager';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/portal/wb/reports`;

export default function AdminWb({ headers }) {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(null);
  const load = () => axios.get(API, { headers }).then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const client = (rid) => ({
    get: () => axios.get(`${API}/${rid}`, { headers }).then((r) => r.data),
    status: (b) => axios.post(`${API}/${rid}/status`, b, { headers }).then((r) => r.data),
    message: (text) => axios.post(`${API}/${rid}/messages`, { text }, { headers }).then((r) => r.data),
    audit: () => axios.get(`${API}/${rid}/audit`, { headers }).then((r) => r.data),
    identity: (reason) => axios.post(`${API}/${rid}/identity`, { reason }, { headers }).then((r) => r.data),
    download: async (f) => { const r = await axios.get(`${API}/${rid}/files/${f.id}`, { headers, responseType: 'blob' }); const a = document.createElement('a'); a.href = URL.createObjectURL(r.data); a.download = f.name; a.click(); },
  });
  return (
    <div className="bg-[#0B0D10] border border-[#1F242C] p-6 text-white" data-testid="admin-wb">
      <h3 className="font-heading text-sm uppercase tracking-widest text-[#BFBFBF] flex items-center gap-2 mb-1"><Megaphone size={14} className="text-[#D4AF37]" />Whistleblowing · Smart Info gestore esterno</h3>
      <p className="text-xs text-[#5A5F67] mb-4">Segnalazioni affidate a Smart Info dalle aziende clienti. Ogni consultazione viene registrata.</p>
      <ReportsTable rows={rows} onOpen={setOpen} testid="admin-wb-reports" />
      <Dialog open={!!open} onOpenChange={(o) => { if (!o) { setOpen(null); load(); } }}>
        <DialogContent className="bg-[#0B0D10] border-[#1F242C] text-white max-w-4xl max-h-[92vh] overflow-y-auto" data-testid="admin-wb-dialog">
          <DialogTitle className="sr-only">Segnalazione</DialogTitle>
          {open && <WbCase key={open.id} rid={open.id} client={client(open.id)} />}
        </DialogContent>
      </Dialog>
    </div>
  );
}
